const parametrit = {
  laina_aika: 20,
  korko_okt: 2,
  korko_muut: 4,
  kayttoika: 20,
  sahkon_hinta: 125, // €/MWh
};

export default parametrit;
